
export default function () {
    function blockResize() {
        let documentWidth = document.documentElement.clientWidth;
        let slideContent = document.querySelector('.single-project__right-slider-slide-content');
        let windowWidth = documentWidth;
        let sliderImage = document.querySelector('.single-project__right-slider-image');
        let imageHeight = sliderImage.height;
        let pagination = document.querySelectorAll('.swiper-pagination');
        let paginationHeight = pagination.height;
        let everest = document.querySelector('.single-project__title--mobile');

        let imageWidth = sliderImage.width;
        let imageBlocks = document.querySelectorAll('.single-project__slider-block');
        let newSizeWidth = windowWidth / 2 - 30;
        let windowHeight = window.innerHeight
        let container = document.querySelector('.single-project__container');
        let containerStyles = window.getComputedStyle(container);
        let containerPadding = containerStyles.getPropertyValue("padding-bottom");
        let singleProject = document.querySelector('.single-project');
        let everest_padding = 0;

        let header = document.querySelector('.header');
        let headerHeight = header.offsetHeight;
        if (singleProject) {
            singleProject.style.paddingTop = headerHeight + 'px';
        }
        let newSizeHeight = windowHeight / 2;
        if (windowWidth >= 992) {

            imageBlocks.forEach(function(block) {
                block.setAttribute('style', '');
                block.style.width = (newSizeWidth) + 'px';
                if (newSizeWidth * 2 - 30 < windowWidth) {
                    block.style.maxWidth = imageHeight + 'px';
                } else {
                    block.style.maxWidth = newSizeWidth + 'px';
                }

            });

        } else {

            imageBlocks.forEach(function(block) {
                block.setAttribute('style', '');
                block.style.width = newSizeWidth + 'px';
                block.style.maxWidth = imageHeight + 'px';
            });

            pagination.forEach(function(block) {
                block.setAttribute('style', '');
                block.style.paddingRight = (newSizeWidth - imageHeight)/2 + 'px';
            });

        }

        if(windowWidth < 992){

            imageBlocks.forEach(function(block) {
                block.setAttribute('style', '');
                block.style.height = imageWidth + 'px';
                block.style.maxHeight = `calc(${+newSizeHeight}px - ${+headerHeight}px - 18px)`;
            });
            // console.log(imageBlocks);

            everest_padding = ((container.offsetWidth - sliderImage.offsetHeight)/2) - 24;            
            // console.log(sliderImage.offsetHeight);
        }

        positionArrows(newSizeWidth, imageHeight)
    }

    function positionArrows(newSizeWidth, image_Height) {

        let sliders = document.querySelectorAll(".swiper");


        sliders.forEach(function (slider) {

            let prevArrow = slider.querySelector(".swiper-button-prev");
            let nextArrow = slider.querySelector(".swiper-button-next");

            let arrowTop = 0;
            let currentSlide = slider.querySelector(".swiper-slide-active");

            let right_left = 10;

            if (currentSlide) {

                let image = currentSlide.querySelector("img");

                if (image) {
                    arrowTop = currentSlide.offsetHeight/2;


                    nextArrow.style.bottom = (arrowTop + prevArrow.offsetHeight/2.2) + "px";
                    prevArrow.style.bottom =  (arrowTop + prevArrow.offsetHeight/2.2) + "px";

                    nextArrow.style.right = right_left + "px";
                    prevArrow.style.left = right_left + "px";
                }
            }
        });
    }

    function setRightSlideContentWidth() {

        let leftImage = document.querySelector('.single-project__left-slider-image');
        let rightSlideContent = document.querySelector('.single-project__right-slider-slide-content');
        let hasVerticalScrollbar = false;
        if(rightSlideContent){
            hasVerticalScrollbar = rightSlideContent.scrollHeight > rightSlideContent.clientHeight;

            if (hasVerticalScrollbar) {
                rightSlideContent.style.justifyContent = 'center';
            }
            else {
                rightSlideContent.style.justifyContent = 'center';
            }
        }
    }

    window.addEventListener("resize", function () {
        // setTimeout(function () {
            blockResize();
            setRightSlideContentWidth();
        // }, 10);
    });

    window.addEventListener("load", function () {
        // setTimeout(function () {
            blockResize();
            setRightSlideContentWidth();
        // }, 10);
    });

    window.addEventListener("orientationchange", function () {
        // setTimeout(function () {
            blockResize();
            setRightSlideContentWidth();
        // }, 10);
    });



}